import { useNavigate } from 'react-router-dom';
import { ReactComponent as Arrow } from '../../assets/home/trvto_arrow.svg';
import { useState } from 'react';

const DestinationCard = ({ data, type }) => {
    const navigate = useNavigate();
    const [limit, setLimit] = useState(9);

    const handleNavigate = (path) => {
        if (type === 'destination') {
            navigate(`/search-result/trip/${path}`, {
                state: { limit }
            });
        } else {
            navigate(`/search-result/trip?type=${encodeURIComponent(path)}`, {
                state: {
                    limit
                }
            });
        }
    };
    return (
        <>
            {data.map((item, index) => (
                <div key={index} className='carousel-item' onClick={() => handleNavigate(item.title)}>
                    <img src={item.image} alt={item.title} />
                    <div className='carouselInnerCard'>
                        <div className='innerBorder' />
                        <div className='alignCenter'>
                            <p>{item.title}</p>
                            <button className='carouselCardInnerBtn'>
                                <Arrow />
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default DestinationCard;
